import React from 'react'
import {locale} from '../locale/AppLocale';
import Modal from 'react-modal';
import Loader from "../Components/Loader";

const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content : {
        width:600,
        overflow                   : '',
        top                   : '',
        left                  : '',
        right                 : '',
        bottom                : '',
        marginRight           : '',
        transform             : '',
        padding             : '',
        border             : '',
        background             : '',
        borderRadius             : '',
    }
};

export default class PiecesModal extends React.Component {

    constructor(props){

        super(props);

        this.state = {
            modalIsOpen: true,
            prices:[],
            isSaving:false
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() {

    }

    closeModal() {
        this.setState({modalIsOpen: false});
        if(this.props.onClose){
            this.props.onClose();
        }
    }

    render(){

        let price = this.props.price;

        if(!Array.isArray(price)){
            price = [
                {
                    index:0,
                    label:"",
                    price:price
                }
            ]
        }
        return (
            <Modal
                portalClassName={'shooq-modal'}
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="Pieces Modal"
                shouldCloseOnOverlayClick={false}

            >

                <div className="shooq-modal--box">
                    <div className="shooq-modal--header">
                        <div className="shooq-modal--header--title">{locale.get('convert_product_to_package_by_price')}</div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="shooq-modal--body">
                        <p className="hint-1">{locale.get('convert_product_to_package_by_price_desc')}</p>
                        {
                            price.map((price,index) => (
                                <PriceRow ref={`price-${index}`} key={index} data={price}/>
                            ))
                        }
                    </div>
                    <div className="clearfix"></div>
                    <div className="shooq-modal--footer">



                        <button
                            className="btn-5"
                            style={{marginLeft:5}}
                            onClick={() => {
                                this.setState({
                                    isSaving:true
                                });
                                this.props.onRefuse()
                            }}
                            disabled={this.state.isSaving} >
                            <Loader completed={this.state.isSaving === false} />
                            {locale.get('no_keep_price_as_is')}
                        </button>


                        <button
                            className="btn-1"
                            style={{marginLeft:5}}
                            onClick={() => {
                                let valid = true;
                                const pricesList = []
                                price.forEach((item,index) => {
                                    let data = this.refs[`price-${index}`].getData();
                                    pricesList.push(data)
                                    //    if(data.price < 100){
                                    //        valid = false;
                                    //    }
                                });
                                if(!valid){
                                    return false
                                }
                                this.setState({
                                    isSaving:true
                                });
                                this.props.onSubmit(pricesList)
                            }}
                            disabled={this.state.isSaving} >
                            <Loader completed={this.state.isSaving === false} />
                            {locale.get('update_pieces')}
                        </button>
                        <button className="btn-2" style={{float:'left'}}
                                onClick={() => {
                                    if(this.props.onClose){
                                        this.props.onClose()
                                    }
                                    this.closeModal()
                                }}
                        >{locale.get('cancel')}</button>
                    </div>
                </div>
            </Modal>
        )
    }

}


class PriceRow extends  React.Component{

    constructor(props){
        super(props)
        let pieces = this.getPiecesByPrice(this.props.data.price);
        let price = this.getPriceByPieces(pieces);
        this.state = {
            pieces:pieces,
            price:price
        };
    }

    render(){
        return (
            <div>
                <div className={`input-group input-c`}>
                    {
                        this.props.data.label !== "" &&
                        <div className="simple-label" style={{width: 200}}>{this.props.data.label}</div>
                    }
                    <div>
                        <label className="simple-label" >{locale.get('number_of_pieces')}</label>
                        <input
                            type="number"
                            className="input"
                            onChange={(el) => {
                                this.setState({
                                    pieces:el.target.value,
                                    price:this.getPriceByPieces(el.target.value)
                                })
                            }}
                            min={1}
                            value={this.state.pieces} />
                    </div>
                    <div>
                        <label className="simple-label">
                            { locale.get('price') }
                            <div className="badge badge--small badge--1" style={{marginRight:5}}>{locale.get('price_per_piece')} {this.props.data.price} {locale.get('system_currency')}</div>
                        </label>
                        <input
                            type="number"
                            className="input"
                            min={100}
                            onChange={(el) => {
                                this.setState({
                                    price:el.target.value
                                })
                            }}
                            value={this.state.price} />
                    </div>
                </div>
                {
                    this.state.warning && <div className="alert alert--danger">{this.state.warning}</div>
                }
            </div>
        )
    }

    getPiecesByPrice(price){
        return Math.ceil(100 / price);
    }

    getPriceByPieces(pieces){
        return pieces * this.props.data.price;

    }

    getData(){
        return {
            index:this.props.data.index,
            price:this.state.price,
            pieces:this.state.pieces
        }
    }


}
